import DownloadIcon from '../../../src/images/download_btn.png';
import Resume from '../../images/Resume of Yeasin Hossen.pdf';
import './About.css';

const About = () => {
  return (
    <section id="resume" className="container section">
      <div className="row">
        <div className="col-md-10" data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="500">

          <h2 id="hello_header" className="section___title">Hello!</h2>
          <p className="section__description pe-lg-5">
            I'm Yeasin Hossen, an IT Support Engineer. My professional interests span IT support, networking, system administration, IT security, software development, and technical troubleshooting. I enjoy diagnosing technical issues, understanding how systems work, and delivering reliable solutions that support smooth and efficient IT operations. Technical & Professional Expertise:
            <br />
            <b style={{ textDecoration: 'underline' }}>IT Support & System Administration:</b> Active Directory, Hardware & Software Configuration, Technical & Network Troubleshooting, Application Support, Printer & Peripheral Support.
            <br />
            <b style={{ textDecoration: 'underline' }}>Networking & Operating Systems:</b> TCP/IP Model, DNS, DHCP, VLAN, VPN, Windows, Linux.
            <br />
            <b style={{ textDecoration: 'underline' }}>Programming Languages:</b> C, JavaScript, Python.
            <br />
            <b style={{ textDecoration: 'underline' }}>Productivity & Collaboration Tools:</b> Microsoft 365, Google Workspace.
            <br />
            <b style={{ textDecoration: 'underline' }}>Familiar Technologies:</b> ServiceNow, MS Entra ID, MS Intune, ITIL Fundamentals.
            <br />
            <b style={{ textDecoration: 'underline' }}>Software Development & Tools:</b> React.js, Next.js, Tailwind, Node.js, Express.js, Git, cPanel, Docker, Firebase.
            <br />
            <b style={{ textDecoration: 'underline' }}>Databases & Data Analytics:</b> MySQL, MongoDB, Sequelize, Power BI.
            <br />
            <b style={{ textDecoration: 'underline' }}>Soft Skills:</b> Technical & Interpersonal Communication, Adaptability, Teamwork, Problem-solving.
          </p>

          <a href={Resume} target="_blank" rel="noreferrer" className="section_btn site-btn" data-aos="zoom-in"
            data-aos-easing="linear"
            data-aos-duration="500"><img src={DownloadIcon} alt="" />Download Resume</a>

          <h2 className="education_title">Education</h2>
          <p>B.Sc. in Computer Science & Engineering</p>
          <p>Year: 2020-2024</p>
          <p className="education_description">Green University of Bangladesh</p>
        </div>
      </div>
    </section>
  );
};

export default About;